import React from 'react';
import { Form, Col, Row, InputGroup } from 'react-bootstrap';
import { FormattedNumberInput } from '../../util';
import { DatePicker } from '../../util/date';
import ImmutableUnderReviewFormControl from '../../util/reviewEditControls/ImmutableUnderReviewFormControl';
import YesOrNoFormField from '../../util/form_fields/YesOrNoFormField';
const ClaimGeneralSharedFields = _ref => {
  let {
    claim,
    handleChange
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 3
  }, "Start Date*"), /*#__PURE__*/React.createElement(Col, {
    md: {
      span: 5,
      offset: 4
    }
  }, /*#__PURE__*/React.createElement(ImmutableUnderReviewFormControl, {
    as: DatePicker,
    selected: claim.from_date,
    disabled: claim.is_locked || claim.financials_locked,
    onChange: date => handleChange({
      target: {
        value: date,
        name: 'from_date'
      }
    })
  }))), /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 3
  }, "End Date*"), /*#__PURE__*/React.createElement(Col, {
    md: {
      span: 5,
      offset: 4
    }
  }, /*#__PURE__*/React.createElement(ImmutableUnderReviewFormControl, {
    as: DatePicker,
    selected: claim.to_date,
    disabled: claim.is_locked || claim.financials_locked,
    onChange: date => handleChange({
      target: {
        value: date,
        name: 'to_date'
      }
    })
  }))), /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 3
  }, "Est. Completion Date"), /*#__PURE__*/React.createElement(Col, {
    md: {
      span: 5,
      offset: 4
    }
  }, /*#__PURE__*/React.createElement(ImmutableUnderReviewFormControl, {
    as: DatePicker,
    selected: claim.estimated_completion_date,
    disabled: claim.is_locked || claim.financials_locked,
    onChange: date => handleChange({
      target: {
        value: date,
        name: 'estimated_completion_date'
      }
    })
  }))), /*#__PURE__*/React.createElement(YesOrNoFormField, {
    labelText: "Is the business exempt from the PAYE cap?",
    formName: "business_exempt_from_paye_cap",
    disabled: claim.is_locked || claim.financials_locked,
    checkedField: claim.business_exempt_from_paye_cap,
    onChange: handleChange
  }), /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 3
  }, "Company turnover per accounts"), /*#__PURE__*/React.createElement(Col, {
    md: {
      span: 5,
      offset: 4
    }
  }, /*#__PURE__*/React.createElement(ImmutableUnderReviewFormControl, {
    as: FormattedNumberInput,
    customInput: Form.Control,
    disabled: claim.is_locked || claim.financials_locked,
    onChange: handleChange,
    name: "company_turnover_per_accounts",
    value: claim.company_turnover_per_accounts || '',
    size: "md",
    type: "text"
  }))), /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 3
  }, "Company Staff Costs Per Account"), /*#__PURE__*/React.createElement(Col, {
    md: {
      span: 5,
      offset: 4
    }
  }, /*#__PURE__*/React.createElement(ImmutableUnderReviewFormControl, {
    as: FormattedNumberInput,
    customInput: Form.Control,
    disabled: claim.is_locked || claim.financials_locked,
    onChange: handleChange,
    name: "company_staff_costs_per_account",
    value: claim.company_staff_costs_per_account || '',
    size: "md",
    type: "text"
  }))), /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 3
  }, "CT Rate Override"), /*#__PURE__*/React.createElement(Col, {
    md: {
      span: 5,
      offset: 4
    }
  }, /*#__PURE__*/React.createElement(InputGroup, null, /*#__PURE__*/React.createElement(ImmutableUnderReviewFormControl, {
    onChange: handleChange,
    disabled: claim.is_locked || claim.financials_locked,
    name: "ct_rate_override",
    value: claim.ct_rate_override || '',
    size: "md",
    type: "text"
  }), /*#__PURE__*/React.createElement(InputGroup.Text, null, "%")))));
};
export default ClaimGeneralSharedFields;